import { atom, selector, selectorFamily } from 'recoil'

export const calendarState = atom({
  key: 'scheduledSendingsCalendarState',
  default: {
    month: undefined, //  Date object representing month in calendar navigation
    canPrev: false,
    lists: [],
    sendings: [],
    sendingsLoaded: false,
    days: [],
    selectedDay: undefined,
    selectedSending: undefined,
    timezoneFormatted: undefined
  }
})

export const calendarDayState = selectorFamily({
  key: 'scheduledSendingsCalendarDayState',
  get: date => ({ get }) => {
    const { sendings } = get(calendarState)

    const daySendings = sendings
      .filter(({ dateFormatted }) => dateFormatted === date)
      .sort(({ timeFormatted: a }, { timeFormatted: b }) =>
        a < b ? -1 : a > b ? 1 : 0
      )

    return {
      sendings: daySendings.slice(0, 3),
      more: daySendings.length - 3
    }
  }
})

export const timelineState = atom({
  key: 'scheduledSendingsTimelineState',
  default: {
    day: undefined, //  giorno selezionato YYYY-MM-DD
    sendings: []
  }
})

export const timelineFilteredState = selector({
  key: 'scheduledSendingsTimelineFilteredState',
  get: ({ get }) => {
    const { lists } = get(calendarState)
    const { sendings } = get(timelineState)

    return sendings.filter(
      ({ idList }) => lists.length === 0 || lists.includes(idList)
    )
  }
})

export const timelineEmptyState = selector({
  key: 'scheduledSendingsTimelineEmptyState',
  get: ({ get }) => {
    const { day } = get(timelineState)
    const sendings = get(timelineFilteredState)

    return !!day && sendings.length === 0
  }
})
